import Title from '@/app/components/common/Title'
import { FC } from 'react'

interface Props {
	t: (key: string, options?: any) => string
}
const FiltersPlaceholder: FC<Props> = ({ t }) => {
	return (
		<div>
			<div className="flex justify-start items-center my-6">
				<Title level="3" size="xl" bold>
					{t('filterBy')}
				</Title>
			</div>
			<div className="h-5 w-[100px] bg-text-300 rounded-4xl mb-3 animate-placeholder"></div>
			<div className="mb-5">
				{/* <div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div> */}
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
			</div>
			{/* <div className="map-placeholder rounded-2xl overflow-hidden mb-5 border border-text-200">
				<div className="w-full h-[100px] bg-text-300  animate-placeholder"></div>
				<div className="text-main py-3 text-center text-sm font-semibold">
					View on a map
				</div>
			</div> */}
			<div className="mb-5">
				<div className="h-5 w-[100px] bg-text-300 rounded-4xl mb-3 animate-placeholder"></div>
				<div className="flex justify-between">
					<div className="border border-text-200 rounded-lg px-3 py-2.5 w-[110px] xl:w-[130px] flex flex-col justify-between">
						<span className="text-text-700 text-xs">{t('min')}</span>
						<div className="h-3 w-[73px] bg-text-300 rounded-4xl me-2.5 my-1 animate-placeholder"></div>
					</div>
					<div className="border border-text-200 rounded-lg px-3 py-2.5 w-[110px] xl:w-[130px] flex flex-col justify-between">
						<span className="text-text-700 text-xs">{t('max')}</span>
						<div className="h-3 w-[73px] bg-text-300 rounded-4xl me-2.5 my-1 animate-placeholder"></div>
					</div>
				</div>
				<div className="fle relative my-5">
					<div className="absolute left-0 -top-2  bg-white flex-col items-center w-5 h-5 outline-none rounded-full border-[6px] border-text-300"></div>
					<div className="h-1 bg-text-300 w-full"></div>
					<div className=" absolute right-0 -top-2 bg-white flex-col items-center w-5 h-5 outline-none rounded-full border-[6px] border-text-300"></div>
				</div>
			</div>
			<div className="h-5 w-[100px] bg-text-300 rounded-4xl mb-3 animate-placeholder"></div>
			<div className="mb-5">
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
			</div>
			<div className="h-5 w-[100px] bg-text-300 rounded-4xl mb-3 animate-placeholder"></div>
			<div className="mb-5">
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
				<div className="checkbox-placeholder h-6 flex items-center justify-start mb-3">
					<div className="rounded w-5 h-5 bg-text-300 me-2.5 animate-placeholder" />
					<div className="h-5 w-[100px] bg-text-300 rounded-4xl me-2.5 animate-placeholder"></div>
				</div>
			</div>
		</div>
	)
}

export default FiltersPlaceholder
